export enum ErrorCode {
  MobilePhoneNotUnique = 'mobilePhoneNotUnique',
  SmsCodeInvalid = 'smsCodeInvalid',
  UserFioAndBirthDayNotUnique = 'userFioAndBirthDayNotUnique',
  UserPassportDataNotUnique = 'userPassportDataNotUnique',
  NotAuthorized = 'not-authorized',
}
